import { useEffect, useState } from "react";

export function useDebouncedSearch(term: string, delay = 300) {
  const [debounced, setDebounced] = useState(term);

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(term), delay);
    return () => clearTimeout(handler);
  }, [term, delay]);

  return debounced;
}
